import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-event-list-dialog',
  templateUrl: './event-list-dialog.component.html',
  // styleUrls: ['./event-list-dialog.component.scss']
})
export class EventListDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EventListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { events: any[], date: Date }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  formatTime(date: Date): string {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
}
